/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Tab_OffersInputs */

const cs_ebr_tab_offers = /** @type {(inputs: Ebr_Tab_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabídky`)
};

const en_ebr_tab_offers = /** @type {(inputs: Ebr_Tab_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offers`)
};

/**
* | output |
* | --- |
* | "Offers" |
*
* @param {Ebr_Tab_OffersInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_tab_offers = /** @type {((inputs?: Ebr_Tab_OffersInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Tab_OffersInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_tab_offers(inputs)
	return cs_ebr_tab_offers(inputs)
});